module.exports = __webpack_public_path__ + "img/cita-medica.2518b187.png";